import Routes from "./routes";
import { GlobalStyles } from "./styles/global";

function App() {
  return (
    <>
    <div className="App">
      <header className="App-header">
      </header>
    </div>
      <Routes />
      <GlobalStyles />
    </>
  );
}

export default App;
